// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import AnimateHeight from 'react-animate-height'
import { FormFieldLayout } from '../../generic'

export default function TextAreaField({
  className,
  errors,
  formKey,
  layout,
  maxLength,
  onChange,
  placeholder,
  readOnly,
  style,
  values,
  ...props
}) {
  const error = get(errors, formKey)
  const value = get(values, formKey) || ''
  const fullClassName = className ? `FormInput ${className}` : 'FormInput'

  if (readOnly) return <ReadOnly value={value} />

  return (
    <FormFieldLayout layout={layout} hasErrors={!!error} {...props}>
      <textarea
        className={fullClassName}
        onChange={(e) =>
          onChange({
            key: formKey,
            value: e.target.value
          })
        }
        maxLength={maxLength}
        placeholder={placeholder}
        style={{
          ...styles.textarea,
          ...style,
          borderColor: error ? colors.red : null
        }}
        value={get(values, formKey) || ''}
        data-testid={props['data-testid']}
      />
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const ReadOnly = ({ value }) => <div style={styles.readOnly}>{value}</div>

const styles = {
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 5
  },
  readOnly: {
    padding: '12px 12px 12px 0px'
  },
  textarea: {
    minHeight: 130
  }
}

TextAreaField.propTypes = {
  maxLength: PropTypes.number
}
